import { simpleLookupConfig } from "../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../lookupManagement";

export const vsObjectName = "contractContactType";

const url = "/api/contract/ContractContactType";

export const contractContactTypeLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Contact Type",
    url,
    defaultSort: "Name",
  }
);
